import { Header, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

import AgentConfiguration from "@/components/agent-config/AgentConfiguration";
import NewChatButton from "@/components/layout/NewChatButton";

const AdminAgentConfigurationPage: React.FC = () => (
  <SpaceBetween size="xl">
    <Header
      variant="h1"
      description="Choose the model MAMBA runs and manage the per-sport season context the agent uses."
      actions={<NewChatButton />}
    >
      Agent Configuration
    </Header>
    <AgentConfiguration />
  </SpaceBetween>
);

export default AdminAgentConfigurationPage;
